export default function getNetworkColumns(trackingMethods, isEditing, editingId, editValues, handleChange) {
  return [
    {
      field: "name",
      headerName: "Nome",
      width: 200,
      renderCell: (params) => {
        if (isEditing && editingId === params.row.id) {
          return (
            <input
              type="text"
              name="name"
              value={editValues.name}
              onChange={handleChange}
              className="w-full rounded-md border border-input px-3 py-1 text-sm"
            />
          );
        }
        return <div className="text-sm">{params.row.name}</div>;
      }
    },
    {
      field: "tracking_method",
      headerName: "Tracking Método",
      width: 200,
      renderCell: (params) => {
        if (isEditing && editingId === params.row.id) {
          return (
            <select
              name="tracking_method"
              value={editValues.tracking_method}
              onChange={handleChange}
              className="w-full rounded-md border border-input px-3 py-1 text-sm"
            >
              {trackingMethods.map((method) => (
                <option key={method} value={method}>{method}</option>
              ))}
            </select>
          );
        }
        return <div className="text-sm">{params.row.tracking_method}</div>;
      }
    },
    {
      field: "template",
      headerName: "Template",
      width: 300,
      renderCell: (params) => {
        if (isEditing && editingId === params.row.id) {
          return (
            <input
              type="text"
              name="template"
              value={editValues.template}
              onChange={handleChange}
              className="w-full rounded-md border border-input px-3 py-1 text-sm"
            />
          );
        }
        return <div className="text-sm break-all">{params.row.template}</div>;
      }
    },
    {
      field: "params",
      headerName: "Parâmetros",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="text-sm break-all overflow-x-auto max-w-xs">
            {JSON.stringify(params.row.params)}
          </div>
        );
      }
    },
    {
      field: "modified_by",
      headerName: "Modificado por",
      width: 200,
      renderCell: (params) => {
        // Se tiver o campo modified_by_username, usa ele, senão verifica o objeto modified_by
        const username = params.row.modified_by_username || 
                         (params.row.modified_by ? params.row.modified_by.username : 'Sistema');
        
        // Formatar a data de modificação, se disponível
        const modifiedDate = params.row.modified_at ? 
          new Date(params.row.modified_at).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          }) : null;
        
        return (
          <div className="flex flex-col">
            <div className="text-sm font-medium">{username}</div>
            {modifiedDate && (
              <div className="text-xs text-muted-foreground">{modifiedDate}</div>
            )}
          </div>
        );
      }
    }    
  ];
}